import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { isTokenExist, setAuthTokens } from "utils/cookies";
import store from "store";
import Axios from "utils/axios";
import { generateBaseUri } from "utils/helper";

const AppConnectPublic = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const endpoint = searchParams.get("endpoint");
  if (token) {
    // Ganti seluruh sesi: refresh_token sesi lama tidak boleh terpasang dengan token baru.
    // refresh_token dkk opsional — tanpa itu sesi tetap jalan, hanya tidak bisa di-refresh.
    setAuthTokens({
      access_token: token,
      refresh_token: searchParams.get("refresh_token"),
      expires_at: searchParams.get("expires_at"),
      refresh_expires_at: searchParams.get("refresh_expires_at"),
    });
  }
  if (endpoint) {
    store.set("app.endpoint", endpoint);
  }

  const tokenExist = isTokenExist();
  Axios.defaults.baseURL = generateBaseUri();

  useEffect(() => {
    navigate("/", { replace: true });
  }, [navigate, tokenExist, endpoint]);
  return null;
};

export default AppConnectPublic;
